import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { JslibModule } from "@bitwarden/angular/jslib.module";
import {
  BerryComponent,
  CardComponent,
  IconModule,
  ScrollLayoutDirective,
  SearchModule,
} from "@bitwarden/components";
import { DangerZoneComponent } from "@bitwarden/web-vault/app/auth/settings/account/danger-zone.component";
import { OrganizationPlansComponent } from "@bitwarden/web-vault/app/billing";
import {
  EnterBillingAddressComponent,
  EnterPaymentMethodComponent,
} from "@bitwarden/web-vault/app/billing/payment/components";
import { OssModule } from "@bitwarden/web-vault/app/oss.module";

import { InvoicesComponent } from "../../billing/providers/billing-history/invoices.component";
import { NoInvoicesComponent } from "../../billing/providers/billing-history/no-invoices.component";
import { ProviderBillingHistoryComponent } from "../../billing/providers/billing-history/provider-billing-history.component";
import { SetupBusinessUnitComponent } from "../../billing/providers/setup/setup-business-unit.component";
import { ProviderSubscriptionStatusComponent } from "../../billing/providers/subscription/provider-subscription-status.component";
import { ProviderSubscriptionComponent } from "../../billing/providers/subscription/provider-subscription.component";
import { EventsComponent } from "../../dirt/provider-events/events.component";

import { BulkConfirmDialogComponent } from "./manage/dialogs/bulk-confirm-dialog.component";
import { BulkRemoveDialogComponent } from "./manage/dialogs/bulk-remove-dialog.component";
import { ProviderActionsService } from "./manage/services/provider-actions/provider-actions.service";
import { ProvidersLayoutComponent } from "./providers-layout.component";
import { ProvidersRoutingModule } from "./providers-routing.module";
import { WebProviderService } from "./services/web-provider.service";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    OssModule,
    JslibModule,
    ProvidersRoutingModule,
    OrganizationPlansComponent,
    IconModule,
    SearchModule,
    ProvidersLayoutComponent,
    DangerZoneComponent,
    ScrollingModule,
    CardComponent,
    ScrollLayoutDirective,
    EnterPaymentMethodComponent,
    EnterBillingAddressComponent,
    BerryComponent,
    BulkConfirmDialogComponent,
    BulkRemoveDialogComponent,
  ],
  declarations: [
    EventsComponent,
    InvoicesComponent,
    NoInvoicesComponent,
    ProviderBillingHistoryComponent,
    ProviderSubscriptionComponent,
    ProviderSubscriptionStatusComponent,
    SetupBusinessUnitComponent,
  ],
  providers: [WebProviderService, ProviderActionsService],
})
export class ProvidersModule {}
